import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getAppRpc } from '../__generated__/chirp/com/hubspot/piesync/bridge/rpc/AppsRpc';
import { getDatasetParametersRpc } from '../__generated__/chirp/com/hubspot/piesync/bridge/rpc/AccountsRpc';
import { createConnectionRpc, activateConnectionRpc, updateConnectionRpc } from '../__generated__/chirp/com/hubspot/piesync/bridge/rpc/ConnectionsRpc';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export function getApp(appId) {
  return chirpClient.call(getAppRpc, {
    request: {
      appId: Number(appId)
    }
  }).then(({
    app
  }) => app);
}
export function postAccountDataset(accountId, __portalId) {
  return chirpClient.call(getDatasetParametersRpc, {
    request: {
      accountId: Number(accountId),
      datasetParameterRequest: {
        remoteObjectType: 'contacts',
        parameters: []
      }
    }
  }).then(({
    parameters
  }) => parameters.map(p => ({
    available: p.available,
    name: p.name,
    options: p.options.map(o => ({
      label: o.label,
      value: o.value
    }))
  })));
}
export function postAccountConnection(accountId, __portalId, __appId, scopes) {
  return chirpClient.call(createConnectionRpc, {
    request: {
      accountId: Number(accountId),
      scopesRequest: {
        objectTypes: {
          hubSpotObjectTypeId: '0-1',
          remote: 'contacts'
        },
        scopes: scopes.map(s => ({
          name: s.name,
          label: s.label,
          value: s.value
        })),
        direction: 'INBOUND'
      }
    }
  }).then(({
    connection
  }) => ({
    id: connection.id,
    status: String(connection.status)
  }));
}
export function putConnection(connectionId, __portalId, __appId) {
  return chirpClient.call(updateConnectionRpc, {
    request: {
      connectionId: Number(connectionId),
      settings: {
        connectionSettings: {
          conflictResolution: 'DEFAULT_TO_HUBSPOT',
          rules: {
            direction: 'INBOUND',
            possibleDirections: [],
            filters: {
              inboundFilters: []
            },
            updateOnlyDirection: 'NONE'
          },
          matchingFilter: {
            name: 'email_only',
            value: true
          },
          defaultValueDatasetParameters: [],
          generalDatasetParameters: [],
          recordIdDatasetParameters: [],
          lastModifiedDatasetParameters: [],
          subscriptionSettingDatasetParameters: []
        },
        fieldMappings: {
          mappings: []
        }
      }
    }
  }).then(() => undefined);
}
export function postConnectionActivate(connectionId, __portalId, __appId) {
  return chirpClient.call(activateConnectionRpc, {
    request: {
      connectionId: Number(connectionId)
    }
  }).then(() => undefined);
}